import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/DataViz Final Logo.svg';
import background from '../assets/images/login-background.jpg'; // Import the image
import '../css/Login.css';

interface LoginProps {
  onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if ((username === 'admin' && password === 'admin') ||
      (username === 'databrix' && password === 'DataBriX9593!')) {
      setError('');
      onLogin();
      navigate('/dashboard');
    } else {
      setError('Invalid username or password.');
    }
  };

  // Event handler for button hover
  const handleMouseOver = (e: React.MouseEvent<HTMLButtonElement>) => {
    (e.target as HTMLButtonElement).style.backgroundColor = '#5a9aff';
  };

  const handleMouseOut = (e: React.MouseEvent<HTMLButtonElement>) => {
    (e.target as HTMLButtonElement).style.backgroundColor = '#007bff';
  };

  const handleFocus = (e: React.FocusEvent<HTMLButtonElement>) => {
    (e.target as HTMLButtonElement).style.backgroundColor = '#5a9aff';
  };

  const handleBlur = (e: React.FocusEvent<HTMLButtonElement>) => {
    (e.target as HTMLButtonElement).style.backgroundColor = '#007bff';
  };

  const handleMouseDown = (e: React.MouseEvent<HTMLButtonElement>) => {
    (e.target as HTMLButtonElement).style.transform = 'translateY(-1px)';
  };

  const handleMouseUp = (e: React.MouseEvent<HTMLButtonElement>) => {
    (e.target as HTMLButtonElement).style.transform = 'translateY(0)';
  };

  return (
    <div className='login-container' style={{ backgroundImage: `url(${background})` }}>
      <div className='login-form-container'>
        <img src={logo} alt='DataBri-X Logo' className='login-logo' />
        <form onSubmit={handleSubmit}>
          <input
            type='text'
            placeholder='Username'
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            className='input-field'
          />
          <input
            type='password'
            placeholder='Password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className='input-field'
          />
          {error && <p className='error-message'>{error}</p>}
          <button
            type='submit'
            className='submit-button'
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
          >
            Login
          </button>
        </form>
      </div>
      <div className='background-overlay'></div>
    </div>
  );
};

export default Login;
